/*
  The Flexi care plan override, on the client.

  The override lives in `engagements_tracks.config.flexiCarePlans`, next to the other
  per-track Flexi settings, and it is read only by the Flexi application. The shared MRX2
  engine, the care_plans table and V5/V6 never see it.

  The decision logic lives in `shared/mrx2/helpers/flexiCarePlans.js` so that the client and
  the server cannot drift apart. This module only adapts it to the client's types.
*/

import {
  applyFlexiCarePlanOverrides as applyOverrides,
  readOverrides,
} from '@shared/clinical-logic/helpers/flexiCarePlans';

export interface FlexiCarePlanOverrideInput {
  /**  The `flexiCarePlans` configuration of the current track, if the engagement has one. */
  config: any;
  /**  The converted responses of the bundle. The `age` response is already in days. */
  responses: any[];
}

export function applyFlexiCarePlanOverrides(bundle: any[], input: FlexiCarePlanOverrideInput): any[] {
  return applyOverrides(bundle, {
    config: input.config,
    responses: input.responses,
  });
}

export function hasFlexiCarePlanOverrides(config: any): boolean {
  return readOverrides(config) !== null;
}
